module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAJ1BMVEUAAAD///////////////////////////////////////////////+uPUo5AAAADXRSTlMAESIzRGZ3iJm7zN3ulOPCIgAAAFJJREFUGNNjODlnJhjMYTBxYZjAyQAGnAzTshEcywOcCI7bBAwOO0j/dFQZITCHNQ0IUsHCEziZXYDAGcqB2TPIOKmaSBypFiQO2wQGRFAxOgAATZovAA7oTAYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/note.png
// module id = 648
// module chunks = 0